/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Deutsch_Lernen17Inputs */

const en__field_enum_tuda_deutsch_lernen17 = /** @type {(inputs: _Field_Enum_Tuda_Deutsch_Lernen17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`improve your proficiency in german`)
};

const de__field_enum_tuda_deutsch_lernen17 = /** @type {(inputs: _Field_Enum_Tuda_Deutsch_Lernen17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch lernen/ verbessern`)
};

/**
* | output |
* | --- |
* | "improve your proficiency in german" |
*
* @param {_Field_Enum_Tuda_Deutsch_Lernen17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_deutsch_lernen17 = /** @type {((inputs?: _Field_Enum_Tuda_Deutsch_Lernen17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Deutsch_Lernen17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_deutsch_lernen17(inputs)
	return de__field_enum_tuda_deutsch_lernen17(inputs)
});
export { _field_enum_tuda_deutsch_lernen17 as "_field_enum_TUDA_DEUTSCH_LERNEN" }